<template>
	<div class="recharge-page">
		<NavBar />

		<!-- 主要内容 -->
		<div class="user-container">
            <div class="num">{{list.length}} / 250</div>
			<el-table
                :data="list"
                border
                stripe
                style="width: 100%">
                <el-table-column prop="phonenumber" label="手机号" > </el-table-column>
                <el-table-column prop="create_time" label="创建日期" > </el-table-column>
            </el-table>
		</div>
	</div>
</template>

<script>
	import NavBar from '@/components/common/NavBar.vue'
	export default {
		name: 'User',

		components: {
			NavBar
		},

		data() {
			return {
				list:[]
			}
		},

		mounted() {
			this.loadRechargeData();
		},
		methods: {
            loadRechargeData() {
				this.HttpUtils.get('/api/external/sys_user', {
					
				}).then(result => {
                    this.list = result.data.data.filter(item => 
                        item.phonenumber && item.phonenumber.trim() !== ''
                    )
				})
			},
			
		},
		beforeDestroy() {
		}
	}
</script>

<style scoped>
	.user-container{
        max-width: 1300px;
        margin: 0 auto;
        padding: 30px 0px;
    }
    .num{
        text-align: right;
        margin-bottom: 10px;
    }
</style>